import { CircularProgress, Paper, Typography } from "@mui/material"
import React, { useContext } from "react"
import { BSUsageAccordion } from "./BSUsageAccordion"
import { BSInputContext } from "../../../../../../../core/context/beem-shot/BSInput/BSInputContext"

interface IProps {
  isDisabled: boolean
  showWarning: boolean
}

export function BSUsageList({ isDisabled, showWarning }: Readonly<IProps>): React.JSX.Element {
  const { bsInput } = useContext(BSInputContext)

  return (
    <Paper sx={{ mt: 1, p: 1, borderRadius: 3 }}>
      <Typography variant="subtitle2" fontSize={14} sx={{ mb: 0.5 }}>
        Configuration de l'ACV
      </Typography>
      {bsInput ? (
        <>
          <BSUsageAccordion isDisabled={isDisabled} showWarning={showWarning} />
          {/* To keep => when we will do several zone we need the divider */}
          {/* {index < bsBuildingZoneList.length - 1 && (
                <Divider sx={{ borderColor: customPalette.lightGray6, borderWidth: 2, mx: -2 }} />
              )} */}
        </>
      ) : (
        <CircularProgress />
      )}
    </Paper>
  )
}
